class @App.Components.TededDropdown
  mobileWidth = 480

  constructor: ->
    @$body = $('body')
    @injectAriaAttributes()
    # To Do: keyboard accessibility
    @addEventListeners()
    @bindElements()
    @bindResizeSensor()

  injectAriaAttributes: ->
    $('[data-dropdown="toggle"],[data-dropdown="panel-open"]')
      .attr('aria-haspopup', 'true')

    $('[data-dropdown="toggle"]').each((i, el) =>
      $el = $(el)
      menuId = TededDropdown.getMenuId($el)
      menuHidden = $(menuId).attr('aria-hidden')
      expanded = if menuHidden is 'false' then 'true' else 'false'
      $(el).attr('aria-expanded', expanded)
    )

  addEventListeners: ->
    document.addEventListener 'tededdropdown.close', (e) ->
      if e.detail.menuId?
        TededDropdown.closeMenu e.detail.menuId
    , false

  bindElements: ->
    @$body.on(
      'click.tededdropdown touchend.tededdropdown',
      '[data-dropdown="toggle"]',
      @dropdownToggle
    )

    @$body.on(
      'click.tededdropdown',
      '[data-dropdown="panel-open"]',
      @panelOpen
    )

    @$body.on(
      'click.tededdropdown',
      '[data-dropdown="panel-close"]',
      @panelClose
    )

  bindResizeSensor: ->
    $('[data-dropdown-anchor]').each () ->
      el = this
      return if $(el).data('resize-off')
      new ResizeSensor el, () ->
        $control = $(el).find('[data-dropdown="toggle"]')
        menuId = TededDropdown.getMenuId $control
        if menuId?
          TededDropdown.checkOffscreenBounds menuId

  panelOpen: (e) =>
    e.preventDefault()
    menuId = TededDropdown.getMenuId $(e.currentTarget)
    $(menuId)
      .closest('[data-dropdown="panel"]')
      .css('transform', 'translate3d(-100%, 0, 0)')
    TededDropdown.openMenu menuId

  panelClose: (e) =>
    e.preventDefault()
    menuId = TededDropdown.getMenuId $(e.currentTarget)
    $(menuId)
      .closest('[data-dropdown="panel"]')
      .css('transform', 'translate3d(0%, 0, 0)')
    TededDropdown.closeMenu menuId

  dropdownToggle: (e) =>
    e.preventDefault()
    $el = $(e.currentTarget)
    menuId = TededDropdown.getMenuId $el

    # If no valid menu exists return early.
    if $(menuId).length < 1
      return false

    if $el.attr('aria-expanded') is 'true'
      TededDropdown.closeMenu menuId
    else
      TededDropdown.openMenu menuId
      TededDropdown.checkOffscreenBounds '[data-dropdown="menu"][aria-hidden="false"]'
      setTimeout () =>
        if $(menuId).attr('aria-hidden') is 'false'
          TededDropdown.bindOutsideClick(menuId)
      , 200

  @closeMenu: (menuId) ->
    $menu = $(menuId)
    $menu.attr 'aria-hidden', 'true'
    $("[href='#{menuId}'][data-dropdown='toggle']").removeClass 'tdd-dropdown--open'
    $menu.find('[aria-hidden="false"]').attr 'aria-hidden', true
    $menu.find('[aria-expanded="true"]').attr 'aria-expanded', false
    $menu
      .find('[data-dropdown="panel"]')
      .css('transform', 'translate3d(0%, 0, 0)')
    $("[href='#{menuId}'][data-dropdown]").attr 'aria-expanded', 'false'
    TededDropdown.unbindOutsideClick menuId

  @openMenu: (menuId) ->
    $menu = $(menuId)
    $menu.attr 'aria-hidden', 'false'
    $("[href='#{menuId}'][data-dropdown='toggle']").addClass 'tdd-dropdown--open'
    $("[href='#{menuId}'][data-dropdown]").attr 'aria-expanded', 'true'

  @bindOutsideClick: (menuId) ->
    $('html').one "click.tededdropdown.#{menuId} touchend.tededdropdown.#{menuId}", (e) =>
      if $(menuId).has(e.target).length < 1
        TededDropdown.closeMenu menuId
      else
        TededDropdown.bindOutsideClick menuId

  @unbindOutsideClick: (menuId) ->
    $('html').off "click.tededdropdown.#{menuId} touchend.tededdropdown.#{menuId}"

  @getMenuId: ($control) ->
    $control.attr('href') || $control.data('menu')

  @checkOffscreenBounds: (selector) ->
    $menu = $(selector)
    $anchor = $menu.closest('[data-dropdown-anchor]');

    return if $anchor.data('resize-off')

    # On mobile dropdowns are full screen width and pinned to the left.
    if window.innerWidth <= mobileWidth
      parentOffset = $menu.closest('[data-dropdown-anchor]').offset().left
      $menu.css
        'transform': ''
        'left': (parentOffset * -1)
      return

    # reset the transform before calculating the position.
    $menu.get(0).style.removeProperty('left');
    $menu.css 'transform', 'translate3d(0, 0, 0)'

    leftbound = $menu.offset().left || 0
    rightBound = leftbound + $menu.width()

    if leftbound < 0
      offset = Math.floor(leftbound - 10) * -1
    else if rightBound >= window.innerWidth
      offset = Math.ceil(window.innerWidth - rightBound - 30)

    $menu.css('transform', "translate3d(#{offset}px, 0, 0)")

$ ->
  if $('[data-dropdown="menu"]').length > 0
    new App.Components.TededDropdown